export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "missionCreation": {
            "steps": {
                "motif": "Reason",
                "period": "Period",
                "details": "Details",
                "invitation": "Invitation",
                "confirmation": "Confirmation",
            },
            "wizard": {
                "stepCount": "Step {current} of {total}",
                "back": "Back",
                "next": "Next",
                "create": "Create the mission",
                "creating": "Creating the mission",
                "backToStep": "Go back to this step",
                "leaveLabel": "Leave mission creation",
                "leaveConfirm": "Are you sure you want to leave this page? Your changes will not be saved.",
            },
            "motif": {
                "title": "Reasons",
                "description": "Select the reason for using temporary work for this mission.",
                "types": {
                    "replacement": "Replacement of one or more absent employees",
                    "activityIncrease": "Temporary increase in activity",
                    "awaitingRecruitment": "Awaiting recruitment",
                    "customaryContract": "Customary temporary contract",
                    "seasonal": "Seasonal employment",
                },
            },
            "period": {
                "title": "Mission period",
                "description": "Enter the start and end dates of the mission.",
                "dateStart": "Start date",
                "dateEnd": "End date",
                "datePlaceholder": "Select",
                "invalidDate": "Please enter a valid date",
                "scheduleTitle": "Schedule",
                "scheduleDescription": "Set the working hours for each day of the mission.",
            },
            "details": {
                "title": "Instructions",
                "description": "Specific to this mission, they do not change the job description.",
                "tempWorker": "For the temp worker",
                "tempWorkerPlaceholder": "E.g. arrive 15 min early and ask for William at the reception",
                "jobbiz": "For the Jobbiz team",
                "jobbizPlaceholder": "E.g. independent profile wanted",
            },
            "invitation": {
                "title": "Work with a profile again?",
                "description": "Select the profiles you want to work with on this mission: selected profiles are given priority. Only available profiles are shown.",
                "searchPlaceholder": "First or last name",
                "searchLabel": "Search for a profile",
            },
            "confirmation": {
                "title": "All good?",
                "description": "Review the mission before creating it. The job description cannot be changed here.",
                "motif": "Reason",
                "period": "Mission period",
                "invitations": "Invited temp workers",
                "tempWorkerInstructions": "Temp worker instructions",
                "jobbizInstructions": "Jobbiz instructions",
                "template": "Job description",
                "none": "None",
                "noneFeminine": "None",
                "editMotif": "Edit the reason",
                "editPeriod": "Edit the period",
                "editInvitations": "Edit the invitations",
                "editTempWorkerInstructions": "Edit the temp worker instructions",
                "editJobbizInstructions": "Edit the Jobbiz instructions",
            },
        },
        "missionTemplate": {
            "tools": {
                "provider": {
                    "company": "Company",
                    "temp_worker": "Temp worker",
                },
                "addLabel": "Add equipment",
                "noOptions": "No equipment available",
                "providerSelectLabel": "Provider",
                "removeLabel": "Remove",
            },
            "pageTitle": {
                "create": "New job template",
                "edit": "Edit job template",
            },
            "steps": {
                "activity": "Business sector",
                "riskyPosition": "High-risk position",
                "prerequis": "Prerequisites",
                "tasks": "Tasks",
                "locationSalary": "Location & pay",
                "confirmation": "Confirmation",
            },
            "wizard": {
                "stepCount": "Step {current} of {total}",
                "back": "Back",
                "next": "Next",
                "save": "Save the template",
                "saving": "Saving…",
                "backToStep": "Back to this step",
                "leaveLabel": "Leave the job template creation",
                "leaveConfirm": "Are you sure you want to leave this page? Your changes will not be saved.",
                "notFound": "Job template not found",
                "activityRequired": "Please select a sector and a qualification",
                "nameRequired": "Please enter the job template title",
                "nameTaken": "A job template already has this name",
                "tasksRequired": "Please keep at least one task",
                "locationRequired": "Please enter an address",
                "salaryRequired": "Please enter an hourly rate",
                "contactRequired": "Please fill in the on-site manager details",
                "created": "Job template created",
                "updated": "Job template updated",
                "createFailed": "Could not create the template",
                "updateFailed": "Could not update the template",
            },
            "activity": {
                "sectorTitle": "Business sector",
                "sectorDescription": "Which sector is the position in?",
                "qualificationTitle": "Qualification",
                "qualificationDescription": "What job does the temp worker do?",
                "qualificationPlaceholder": "Choose a qualification",
                "qualificationNoOptions": "Select the business sector",
                "nameTitle": "Job template title",
                "nameDescription": "It starts with the qualification. Complete it after the dash (e.g. Night, Fresh aisle).",
                "namePlaceholder": "E.g. Order picker - Night",
                "nameSuffixPlaceholder": "E.g. Night",
                "nameTaken": "A job template already has this name.",
            },
            "riskyPosition": {
                "title": "High-risk position",
                "description": "Some positions require reinforced safety training.",
                "question": "Is this a high-risk position?",
                "articleLink": "See article L. 4154-2 of the French Labour Code",
                "listLabel": "High-risk positions concerned",
                "empty": "No high-risk position available",
                "loadError": "Could not load the list of high-risk positions. Please try again later.",
                "selectionRequired": "Please select at least one high-risk position",
                "summaryNo": "No",
                "summaryYes": "Yes",
            },
            "prerequis": {
                "title": "Prerequisites",
                "description": "List the qualifications and equipment essential for these missions.",
                "tools": "Equipment",
                "toolsPlaceholder": "Add equipment",
                "licences": "Licences",
                "languages": "Languages",
                "dressCode": "Dress code",
                "dressCodePlaceholder": "E.g. black trousers, plain white top, safety shoes",
            },
            "tasks": {
                "title": "Job tasks",
                "description": "Tick the suggested tasks or add your own.",
                "addPlaceholder": "Add a task (e.g. receiving deliveries)",
                "addButton": "Add",
                "countOne": "{count} task",
                "countMany": "{count} tasks",
                "selectedOfOne": "selected out of {total}",
                "selectedOfMany": "selected out of {total}",
                "addedByYou": "Added by you",
                "removeLabel": "Remove",
                "noProposal": "No task suggested for this qualification. Add the temp worker's tasks.",
                "duplicate": "This task is already in the list.",
                "tooMany": "The maximum number of tasks has been reached.",
            },
            "locationSalary": {
                "locationTitle": "Workplace",
                "locationDescription": "Where should the temp worker report?",
                "addressLabel": "Address",
                "addressSearchLabel": "Search for a place",
                "salaryTitle": "Pay",
                "salaryDescription": "Gross hourly rate, excluding bonuses and premiums.",
                "salaryPlaceholder": "E.g. 12.50",
                "salaryUnit": "€/h",
                "indexedTooltip": "When the template is indexed to the minimum wage, the rate automatically follows the latest official value.",
                "indexedLabel": "Index to the minimum wage ({smic})",
                "belowMinimumWage": "The rate must be at least the minimum wage ({smic} €/h).",
                "contactTitle": "On-site manager",
                "contactDescription": "The person the temp worker will contact on arrival.",
                "contactName": "Full name",
                "contactPoste": "Position",
                "contactPosteDefault": "Manager",
            },
            "confirmation": {
                "edit": "Edit",
                "title": "All good?",
                "description": "Review the template before saving it. You can edit it later.",
            },
            "summary": {
                "none": "None",
                "noneFeminine": "None",
                "dressCodeMissing": "Not provided",
                "tasksTwo": "{first} and {second}",
                "tasksManyOne": "{first}, {second} and {count} other",
                "tasksMany": "{first}, {second} and {count} others",
                "indexedToMinimumWage": "indexed to the minimum wage",
            },
            "list": {
                "searchPlaceholder": "Search",
                "searchLabel": "Search a job template",
                "create": "Job template",
                "loading": "Loading job templates…",
                "noResult": "No job template matches your search.",
                "perHour": "/h",
                "belowMinimumWage": "Below the minimum wage: update the template before creating a mission.",
            },
            "preview": {
                "defaultTitle": "Job template",
                "closeLabel": "Close the preview",
                "edit": "Edit",
                "delete": "Delete",
                "duplicate": "Duplicate",
                "createMission": "Create a mission",
                "belowMinimumWage": "Hourly rate below the minimum wage: edit the template to use it.",
                "belowMinimumWageToast": "This template is below the minimum wage, update it before using it.",
                "fields": {
                    "name": "Title",
                    "activity": "Sector",
                    "qualification": "Qualification",
                    "riskyPosition": "High-risk position",
                    "tools": "Equipment",
                    "licences": "Licences",
                    "languages": "Language",
                    "dressCode": "Dress code",
                    "address": "Address",
                    "salary": "Gross hourly rate",
                    "contact": "Manager",
                    "tasks": "Tasks",
                },
            },
        },
        "missionFiche": {
            "tasksTitle": "Tasks of the {title}",
            "tasksTitleElided": "Tasks of the {title}",
        },
        "perimeters": {
            "tab": "Perimeters",
            "title": "Perimeters",
            "description": "Define what your managers can access to manage missions, contract signatures and timesheets",
            "roles": {
                "200": "Observer",
                "205": "Manager",
                "210": "Supervisor",
                "215": "Director",
                "220": "Coordinator",
                "225": "Administrator",
            },
            "list": {
                "loading": "Loading perimeters…",
                "loadError": "Could not load the perimeters.",
                "forbidden": "You do not have the rights required to manage perimeters.",
                "retry": "Retry",
                "create": "Create",
                "edit": "Edit",
                "archive": "Archive",
                "members": {
                    "one": "{count} member",
                    "many": "{count} members",
                },
                "noMembers": "No member attached",
            },
            "empty": {
                "title": "No perimeter yet",
                "description": "Without a perimeter, all your managers see every mission, contract and timesheet. Create perimeters (a department, a site, a team...) to limit their access.",
            },
            "form": {
                "createTitle": "Create a perimeter",
                "createDescription": "Attach the members who will manage the missions of this perimeter. Members without a perimeter still see everything.",
                "nameLabel": "Perimeter name",
                "namePlaceholder": "E.g. Kitchen, Lamentin site, Night team",
                "membersLabel": "Attached members (optional)",
                "searchPlaceholder": "Search a member",
                "noAssignableMember": "No member to attach for now.",
                "noSearchResult": "No member matches your search.",
                "create": "Create",
                "creating": "Creating…",
                "editTitle": "Edit “{name}”",
                "editDescription": "Changes apply right away to the members' access.",
                "save": "Save",
                "saving": "Saving…",
            },
            "modal": {
                "cancel": "Cancel",
            },
            "delete": {
                "title": "Delete “{name}”?",
                "description": "This perimeter is not attached to any mission. It will be permanently deleted.",
                "confirm": "Delete",
                "deleting": "Deleting…",
            },
            "archive": {
                "title": "Archive “{name}”?",
                "transferTitle": "Archive “{name}”",
                "finishedMissions": {
                    "one": "The finished mission keeps this perimeter in its history.",
                    "many": "The {count} finished missions keep this perimeter in their history.",
                },
                "notProposed": "It will no longer be offered for new missions and you can restore it at any time.",
                "activeMissions": {
                    "one": "{count} ongoing or upcoming mission",
                    "many": "{count} ongoing or upcoming missions",
                },
                "transferIntro": "{missions} and {members} are attached to this perimeter. Finished missions keep it in their history.",
                "transferLabel": "Transfer the missions and the members to",
                "noPerimeter": "No perimeter",
                "confirm": "Archive",
                "archiving": "Archiving…",
                "usageError": "Could not check the access of the members concerned.",
            },
            "restore": {
                "title": "Restore “{name}”?",
                "description": {
                    "one": "This perimeter comes back without members. Its finished mission will be restricted to it again: until you attach members, only administrators, directors and members without a perimeter will see it.",
                    "many": "This perimeter comes back without members. Its {count} finished missions will be restricted to it again: until you attach members, only administrators, directors and members without a perimeter will see them.",
                },
                "restoring": "Restoring…",
            },
            "alert": {
                "membersAccess": {
                    "one": "The member concerned will have access to every mission, contract and timesheet.",
                    "many": "The {count} members concerned will have access to every mission, contract and timesheet.",
                },
            },
            "archived": {
                "heading": "Archived ({count})",
                "archivedOn": "Archived on {date}",
                "finishedMissions": {
                    "one": "{count} finished mission",
                    "many": "{count} finished missions",
                },
                "restore": "Restore",
                "loadError": "Could not load the archived perimeters.",
            },
            "toast": {
                "created": "Perimeter created",
                "updated": "Perimeter updated",
                "archived": "Perimeter archived",
                "deleted": "Perimeter deleted",
                "transferred": {
                    "one": "{count} mission transferred to {name}",
                    "many": "{count} missions transferred to {name}",
                },
                "archivedNoPerimeter": {
                    "one": "Perimeter “{name}” archived · {count} mission has no perimeter anymore",
                    "many": "Perimeter “{name}” archived · {count} missions have no perimeter anymore",
                },
                "restored": "Perimeter “{name}” restored",
            },
            "errors": {
                "generic": "Something went wrong. Please try again.",
                "nameRequired": "The perimeter name is required.",
                "nameTooLong": "This name is too long.",
                "nameTaken": "A perimeter already has this name (active or archived).",
                "memberInvalid": "This member is no longer available: the list has been refreshed.",
                "notFound": "This perimeter no longer exists.",
                "archived": "This perimeter is archived: restore it before editing it.",
                "alreadyArchived": "This perimeter is already archived.",
                "notArchived": "This perimeter is no longer archived.",
                "inUse": "This perimeter has already been attached to a mission: it can no longer be deleted, only archived.",
                "transferInvalid": "The chosen perimeter is no longer available for the transfer.",
            },
            "missionStep": {
                "step": "Details",
                "title": "Perimeter",
                "placeholder": "Select",
                "noPerimeter": "No perimeter",
                "noPerimeterHint": "Visible to all managers",
                "help": "Only the managers of this perimeter will see the mission, its contracts and its timesheets. Without a perimeter, it is visible to everyone.",
                "restrictedHelp": "You can only attach a mission to your perimeters: {names}.",
                "next": "Next",
                "errors": {
                    "required": "Choose a perimeter for this mission.",
                    "forbidden": "You cannot attach the mission to this perimeter. Choose another one.",
                    "archived": "This perimeter has just been archived. Choose another one.",
                    "notFound": "This perimeter no longer exists. Choose another one.",
                },
            },
            "missionDetail": {
                "label": "Perimeter",
                "none": "None",
                "archived": "(archived)",
                "edit": "Edit",
            },
            "listFilter": {
                "button": "Perimeter",
                "count": "{count} perimeters",
                "noPerimeter": "No perimeter",
                "noPerimeterHint": "Visible to all managers",
                "clear": "Clear",
                "column": "Perimeter",
                "errors": {
                    "invalid": "This perimeter filter is not valid: it has been cleared.",
                    "forbidden": "You no longer have access to one of these perimeters: the filter has been cleared.",
                    "notFound": "One of these perimeters no longer exists: the filter has been cleared.",
                },
            },
            "changeMission": {
                "title": "Change the perimeter",
                "recap": "{title} – no. {number}, {status}.",
                "recapWithoutNumber": "{title}, {status}.",
                "appliesNow": "The change applies immediately.",
                "status": {
                    "inProgress": "in progress",
                    "upcoming": "upcoming",
                    "finished": "finished",
                },
                "label": "New perimeter",
                "confirm": "Change",
                "changing": "Changing…",
                "and": " and ",
                "losingAccess": {
                    "one": "{names} will no longer have access to this mission, its contracts and its timesheets.",
                    "many": "{names} will no longer have access to this mission, its contracts and its timesheets.",
                },
                "optionsError": "Could not load the perimeters.",
                "previewError": "Could not check the access of the managers concerned.",
                "errors": {
                    "missionFinished": "This mission is finished: its perimeter can no longer be changed.",
                    "archived": "This perimeter has just been archived. Choose another one.",
                    "notFound": "This perimeter no longer exists. Choose another one.",
                    "forbidden": "You cannot attach the mission to this perimeter. Choose another one.",
                    "missionAccessDenied": "You no longer have access to this mission.",
                },
            },
        },
        "missionAccess": {
            "back": "Back",
            "mission": {
                "title": "You don't have access to this mission",
                "description": "It is not in your perimeter. Please contact your administrator.",
            },
            "document": {
                "title": "You don't have access to this document",
                "description": "This contract or timesheet belongs to a mission or a company you don't have access to. Please contact your administrator.",
            },
        },
        "contract": {
            "documentUnavailable": "The contract document is not available yet. Please try again later or contact your agency.",
        },
        map : new Map()
    }
}